import { BreadcrumbOptions } from "@/components/breadcrumbs";
import { PageHeader } from "@/components/page-header";
import { Skeleton } from "@/components/ui/skeleton";
import { T } from "@/i18n";
import {
  Accommodation,
  Reservation,
  ReservationClient,
  ReservationDay,
  ReservationService,
} from "@/models";
import { BookOpen } from "lucide-react";
import { ReservationFormProvider } from "./provider";

export function Form({
  reservation,
  clients,
  accommodations,
  reservationdays,
  services,
  crumbs,
  isLoading,
  onSuccess,
}: {
  reservation?: Reservation;
  clients: ReservationClient[];
  accommodations: Accommodation[];
  services: ReservationService[];
  reservationdays: ReservationDay[];
  crumbs: BreadcrumbOptions[];
  isLoading: boolean;
  onSuccess: (id: string) => void;
}) {
  return (
    <>
      <PageHeader
        breadcrumbs={[
          {
            content: (
              <>
                <T tKey="reservations.title" />{" "}
                <BookOpen width={16} height={16} />
              </>
            ),
            href: "/reservations",
          },
          ...crumbs,
        ]}
      />
      <div className="flex flex-1 flex-col gap-4 p-4">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-semibold text-primary">
            {isLoading ? (
              <Skeleton className="h-11 w-28" />
            ) : (
              <T
                tKey={
                  reservation
                    ? "reservations.update.title"
                    : `reservations.new.title`
                }
              />
            )}
          </h1>
        </div>
        <div className="w-full">
          {isLoading ? (
            <div className="grid gap-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} className="h-11 w-full" />
              ))}
            </div>
          ) : (
            <ReservationFormProvider
              model={reservation}
              clients={clients}
              accommodations={accommodations}
              services={services}
              reservationDays={reservationdays}
              onSuccess={onSuccess}
            />
          )}
        </div>
      </div>
    </>
  );
}
